module.exports = __webpack_public_path__ + "img/bzip.e7db7de3.svg";